import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useRootPath = ()=>{
  const location = useLocation();
  const rootPath = useMemo(() => {
    const _rootPath = location.pathname.split('/')[1];
    return _rootPath;
  }, [location]);
  return rootPath;
}